import { isValidEmail } from './utils';

export const MAX_SECTION_NAME_LEN = 200;
export const MAX_SECTION_LEVEL_LEN = 120;
export const MAX_PERSON_NAME_LEN = 120;
export const MAX_EMAIL_LEN = 254;

/** Validate Add Class tabs before sections POST. */
export const validateClassListForCreateApi = (classList) => {
    if (!Array.isArray(classList)) {
        return { ok: false, message: 'Invalid form state. Close the dialog and try again.' };
    }
    const withName = classList.filter((c) => (c.className || '').trim());
    if (withName.length === 0) {
        return { ok: false, message: 'Enter a class name on at least one tab.' };
    }
    for (const c of classList) {
        const name = (c.className || '').trim();
        if (!name) continue;
        if (name.length > MAX_SECTION_NAME_LEN) {
            return { ok: false, message: `Class name must be at most ${MAX_SECTION_NAME_LEN} characters.` };
        }
        const level = (c.gradeLevel || '').trim();
        if (level.length > MAX_SECTION_LEVEL_LEN) {
            return { ok: false, message: `Grade level must be at most ${MAX_SECTION_LEVEL_LEN} characters.` };
        }
        const te = (c.teacherEmail || '').trim();
        if (te.length > MAX_EMAIL_LEN) {
            return { ok: false, message: 'Teacher email is too long.' };
        }
        if (te && !isValidEmail(te)) {
            return { ok: false, message: 'Enter a valid teacher email, or leave it blank.' };
        }
        const tf = (c.teacherFirstName || '').trim();
        const tl = (c.teacherLastName || '').trim();
        if (tf.length > MAX_PERSON_NAME_LEN || tl.length > MAX_PERSON_NAME_LEN) {
            return { ok: false, message: `Teacher names must be at most ${MAX_PERSON_NAME_LEN} characters each.` };
        }
    }
    return { ok: true };
};
